var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.waiting)?_c('div',[_c('img',{class:_vm.sizeCss,attrs:{"src":"/images/spinner.gif","alt":"loading"}})]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }